export const colorConstants = {
  SUCCESS: 'COLOR_SUCCESS',
  ERROR: 'COLOR_ERROR',
  CLEAR: 'COLOR_CLEAR',
};
